/**
 * Trunnion AI - Template Gallery Page
 * /templates - Browse and instantiate workflow templates.
 */

import { TemplateGallery } from '@/components/templates/TemplateGallery';

export default function TemplateGalleryPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Workflow Templates</h1>
        <p className="text-sm text-trunnion-slate-400 mt-1">
          Browse pre-built workflow templates and create new workflows from proven patterns.
        </p>
      </div>
      <TemplateGallery />
    </div>
  );
}
